/**
 * Platform and Channel are collapsed by default behind one "Platform & Channel"
 * button (#4626), so the header needs two things the old always-visible chip
 * rows didn't: a count of how many are active (for the button) and a flat list
 * of removable pills (so a selection stays visible/removable without opening
 * the popover). Pure so both are testable without mounting the header.
 */
export interface CollapsedFacetPill {
  dimension: 'dsp' | 'channel';
  value: string;
  label: string;
}

export const countCollapsedFacetFilters = (dsps: string[], channelIds: string[]): number =>
  dsps.length + channelIds.length;

export const buildCollapsedFacetPills = (
  dsps: string[],
  channelIds: string[],
  dspLabelFor: (value: string) => string,
  channelLabelFor: (value: string) => string,
): CollapsedFacetPill[] => [
  ...dsps.map(value => ({ dimension: 'dsp' as const, value, label: `Platform: ${dspLabelFor(value)}` })),
  ...channelIds.map(value => ({ dimension: 'channel' as const, value, label: `Channel: ${channelLabelFor(value)}` })),
];
